import React from 'react';
import PropTypes from 'prop-types';
import BaseLayout from '../../../layouts/BaseLayout/BaseLayout';
import Navigation from '../../../components/Navigation/Navigation';

const ReviewTwoColumnLayout = ({ header, children, className }) => {
  return (
    <BaseLayout header={header} sidebar={<Navigation />} className={className}>
      {children}
    </BaseLayout>
  );
};

ReviewTwoColumnLayout.propTypes = {
  header: PropTypes.oneOfType([PropTypes.element, PropTypes.node]),
};

export default ReviewTwoColumnLayout;
